import React, { useState } from 'react';
import { SlideDown } from 'react-slidedown';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Price } from 'models/price';
import { getFormattedPrice } from 'utils/currency';

import { Arrow, Card, Division, Header, Label, Row, Section, Title, Total, TotalLabel, Value } from './styles';

interface Props {
  price: Price;
}

const PriceBox = ({ price }: Props) => {
  const { t } = useStoreTranslation();
  const [show, setShow] = useState(true);

  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: price.currencyCode, t });
    return formatted;
  };

  const discountValue =
    price.discountAmount && price.discountAmount > 0 ? price.discountAmount * -1 : price.discountAmount;

  return (
    <Card>
      <Header onClick={() => setShow(!show)}>
        <Title>{`1 ${t('flightDetails.price.adult')}`}</Title>
        <Arrow className={show ? 'active' : ''} />
      </Header>
      <SlideDown closed={!show}>
        <Division />
        <Section>
          <Row>
            <Label>{t('flightDetails.price.fare')}</Label>
            <Value>{formattedPrice(price.amount)}</Value>
          </Row>
          <Row>
            <Label>{t('flightDetails.price.taxes')}</Label>
            <Value>
              {formattedPrice((price.taxes || price.taxesValue || 0) + (price.fees || 0) + (price.surcharges || 0))}
            </Value>
          </Row>
          <Row>
            <Label>{t('flightDetails.price.discount')}</Label>
            <Value>{formattedPrice(discountValue)}</Value>
          </Row>
        </Section>
        <Division />
        <Section>
          <Row>
            <TotalLabel>{t('flightDetails.price.total')}</TotalLabel>
            <Total>{formattedPrice(price.total)}</Total>
          </Row>
        </Section>
      </SlideDown>
    </Card>
  );
};

export default PriceBox;
